import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import { PowerBiEmbedResponse } from '@api/models/powerbi.model';

@Injectable({
  providedIn: 'root',
})
export class PowerBiEmbedService {
  private http = inject(HttpClient);
  private appService = inject(AppService);

  getEmbedConfig(): Observable<PowerBiEmbedResponse> {
    const municipalityId = this.appService.municipalityId();
    const headers: Record<string, string> = {};

    if (municipalityId) {
      headers['X-Municipality-Id'] = municipalityId;
    }

    return this.http.get<PowerBiEmbedResponse>(
      `${environment.apiUrl}/powerbi/embed-config`,
      { headers }
    );
  }
}
